import React from 'react';

const ForeignInvestment = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Foreign Investment in Real Property Tax Act of 1980 (FIRPTA)
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          The disposition of a U.S. real property interest by a foreign person
          (the transferor) is subject to the Foreign Investment in Real Property
          Tax Act of 1980 (FIRPTA) income tax withholding. FIRPTA authorized the
          United States to tax foreign persons on dispositions of U.S. real
          property interests. This includes but is not limited to a sale or
          exchange, liquidation, redemption, gift, transfers, etc. Persons
          purchasing U.S. real property interests (transferee) from foreign
          persons, certain purchasers’ agents, and settlement officers are
          required to withhold up to 15 percent of the amount realized (special
          rules for foreign corporations). Withholding is intended to ensure
          U.S. taxation of gains realized on disposition of such interests. The
          transferee/Buyer is the withholding agent. If you are the
          transferee/Buyer you must find out if the transferor is a foreign
          person as defined by the Act. If the transferor is a foreign person
          and you fail to withhold, you may be held liable for the tax.
        </li>
      </ol>
    </div>
  );
};

export default ForeignInvestment;
